
export const helpArticleModalSelected = state  => state?.help_article?.help_article_modal;
export const helpArticleSendCommentMailSelected = state  => state?.help_article?.send_mail;
